/** Calculate the tax return added value and total charges */
export function calculateTaxReturnsTotal(data) {
    if (!data)    
        return 0;
        
    let merchPurchase       = Number(data.fs_2052) ?? 0
    let rawMaterialPurchase = Number(data.fu_2052) ?? 0
    let otherPurchase       = Number(data.fw_2052) ?? 0
    let licensesRoyalties   = Number(data.a4_2053) ?? 0
    let interests           = Number(data.gr_2052) ?? 0
    let vmpTransfer         = Number(data.gt_2052) ?? 0

    // Calculate total charges
    let totalCharges = merchPurchase + rawMaterialPurchase + otherPurchase + licensesRoyalties + interests + vmpTransfer

    // Calculate added_value
    let unionDues = Number(data.es_2058) ?? 0

    let a1a2_1329 = Number(data.a1a2_1329) ?? 0
    let a3_1330 = Number(data.a3_1330) ?? 0
    let totalCa = a1a2_1329 + a3_1330

    return (
        { 
            addedValue: totalCa - totalCharges + unionDues,
            totalCharges: totalCharges
        }
    )
}
